export default class WrapHeadingText {
    constructor(element, headingSelector) {
        this.element = element;
        this.headingSelector = headingSelector;

        this.init();
    }

    init() {
        const heading = this.element.querySelector(this.headingSelector);

        this.wrapText(heading);
    }

    // Function to wrap heading text in span elements
    wrapText(heading) {
        if (!heading) return;

        let text = heading.innerHTML.trim();
            text = text.replace(/<br\s*\/?>/gi, ' ').trim();

        let words = text.split(/\s+/),
            mid = Math.ceil(words.length / 2),
            firstHalf = words.slice(0, mid).join(' '),
            secondHalf = words.slice(mid).join(' ');

        // Update the heading with the two parts wrapped in <span>
        heading.innerHTML = `<span>${firstHalf}</span><span>${secondHalf}</span>`;
    }
}